const TARGET_PAIRS = [
  ["cpp_stl_98", "clang3.4-linux-x86_64"],
  ["cpp_stl_98", "clang18-linux-x86_64"],
  ["cpp_stl_98", "gcc4.8-linux-x86_64"],
  ["cpp_stl_98", "gcc13-linux-x86_64"],
  ["cpp_stl_98", "clang17-macos-x86_64"],
  ["cpp_stl_98", "msvc141-windows-x64"],
  ["cpp_stl_11", "clang3.4-linux-x86_64"],
  ["cpp_stl_11", "clang18-linux-x86_64"],
  ["cpp_stl_11", "gcc4.8-linux-x86_64"],
  ["cpp_stl_11", "gcc13-linux-x86_64"],
  ["cpp_stl_11", "clang17-macos-x86_64"],
  ["cpp_stl_11", "msvc141-windows-x64"],
  ["csharp", "net48-windows-x64"],
  ["csharp", "net8.0-linux-x86_64"],
  ["csharp", "net10.0-linux-x86_64"],
  ["graphviz", "12-linux-x86_64"],
  ["go", "1.27-linux-x86_64"],
  ["java", "temurin8-linux-x86_64"],
  ["java", "temurin11-linux-x86_64"],
  ["java", "temurin17-linux-x86_64"],
  ["java", "temurin21-linux-x86_64"],
  ["java", "temurin25-linux-x86_64"],
  ["javascript", "nodejs12-linux-x86_64"],
  ["javascript", "nodejs18-linux-x86_64"],
  ["javascript", "nodejs26-linux-x86_64"],
  ["lua", "5.3-linux-x86_64"],
  ["lua", "5.4-linux-x86_64"],
  ["lua", "5.5-linux-x86_64"],
  ["nim", "1.6.20-linux-x86_64"],
  ["nim", "2.2.12-linux-x86_64"],
  ["perl", "5.44-linux-x86_64"],
  ["php", "7.1-linux-x86_64"],
  ["php", "8.5-linux-x86_64"],
  ["python", "3.8-linux-x86_64"],
  ["python", "3.15-linux-x86_64"],
  ["construct", "python3.6-linux-x86_64"],
  ["construct", "python3.15-linux-x86_64"],
  ["ruby", "2.4-linux-x86_64"],
  ["ruby", "4.0-linux-x86_64"],
  ["rust", "1.99-linux-x86_64"],
  ["zig", "0.16.0-linux-x86_64"],
];
TARGET_PAIRS.forEach(pair => Object.freeze(pair));
Object.freeze(TARGET_PAIRS);

export default TARGET_PAIRS;
